export default __webpack_public_path__ + "assets/hexpattern.b577bbe2.svg";